
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;

export const visitApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
       getVisitCounter: builder.query({
      query: (data) => ({
        url: `${USERS_URL}/admin/get-visitor`,
        method: 'get',
        credentials: "include",
      }),
    }),

   trackVisitor: builder.mutation({
  query: () => ({
    url: `${USERS_URL}/admin/track-visit`,
    method: 'POST',
    credentials: 'include',
  }),
}),

  }),
});

// Export hooks for usage in components
export const {
useGetVisitCounterQuery,useTrackVisitorMutation
} = visitApiSlice;
